// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.9999 5.65341L11.9983 0.450195L2.99917 5.65195L11.9984 10.8458L20.9999 5.65341Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.9983 7.38641L12.9983 12.5779V22.9725L21.9983 17.7705V7.38641Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.9983 22.9655V12.5778L1.99829 7.3835V17.7005L10.9983 22.9655Z"}}]};

const ControlPlatformFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'control-platform-filled',
    ref,
    icon: element,
  },
));

ControlPlatformFilledIcon.displayName = 'ControlPlatformFilledIcon';

export default ControlPlatformFilledIcon;
